<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/WhQ95D/tc-custom/9781449496821.jpg?1737683996764" alt="This image is the cover for the book I Hope My Voice Doesn't Skip"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">I Hope My Voice Doesn't Skip
      </h1>
      <p class="bookDescription body article font2">
        <b>Anthem-like poems about relationships, mental health, loss, and recovery from the activist and bestselling author of <i>Stuff I’ve Been Feeling Lately</i>.</b><br/><br/>The reader’s experience with this unique collection is lifted from the page as Alicia Cook has collaborated with a number of up and coming musicians to transform some of her poetry into song. Like her debut book, this one is divided into two parts. Modeled after a vinyl record this time, the collection is separated into the EP record, holding Cook’s shorter poetry, and the LP record, holding Cook’s longer poetry, prose, and songwriting. Together, they form an inspiring collection for all those recovering from something.<br/><br/><b>“Through each internal rhyme and turn of phrase, she presents new ways of interpreting despair, courage and overcoming. The poems are mostly devoid of gender pronouns, favoring the first and second person to promote accessibility for all. Cook is self-reliant and fully aware of how to make her voice heard.” —<i>Asbury Park Press</i> </b><br/><br/><b>“This book was raw . . . Alicia Cook writes about very important topics, some of them really hard to read about, especially if they hit too close to home . . . You will <i>always </i>find a poem, a sentence, something that will speak to you, to your heart, to what you’re going through and this book did just that for me.” —<i>Chapter Ninety-Two</i></b><br/><br/><b>“A heartfelt, emotional, beautiful book of poems.” —<i>The Pages In-Between</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Alicia Cook
      </h2>
      
      <p class="authorDescription body article">Alicia Cook is a writer and creative living in Newark, New Jersey whose words have been highlighted in Teen Vogue, CNN, and USA Today. Her poetry is usually unfixed and covers various topics and emotions. Her poetry mixtape, "Stuff I've Been Feeling Lately" was a finalist in the 2016 Goodreads Choice Awards. When Cook is not creating poetry or drinking coffee, she is writing about addiction and its direct effect on families. Her series, "The Other Side of Addiction," written in honor of her cousin Jessica who lost her life to heroin, has developed a worldwide readership. These are very personal accounts, written to shed light on this deadly epidemic and prove that anyone can be affected. Her efforts were featured on the episode "A Family Disease" by the Emmy nominated documentary series, "Here's the Story". Alicia Cook currently writes full-time as the Director of Institutional Communications at Bloomfield College. She loves the ocean, French fries, champagne, and spending time with her family.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Andrews McMeel Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?fe0cc5ac